export const songPathUrl = path => path
  ? '/songs/' + path.split('/').map(encodeURIComponent).join('/')
  : '/songs';

export const songPathFromUrl = pathname => pathname.replace(/^\/songs\/?/, '').split('/').map(part => {
  try { return decodeURIComponent(part); }
  catch { return part; }
}).join('/');
